import { FormatUtils } from '@front/volcanion/utils'

class OrderCallbacks {
  static formToFilterHandler(codeIntlPhone, mode) {
    return function formToFilter(values) {
      const { quick, transport, billing, b2b } = values

      const { requestedAt, priority, loads, source, ...rest_quick } = quick || {}
      const { company, contract, service, ...rest_b2b } = b2b || {}
      const { commercial_formula, ...rest_transport } = transport || {}
      const { billing_status, ...rest_billing } = billing || {}
      const order_client_id = mode === 'billing' ? billing?.order_client_id : quick?.order_client_id
      return _.merge({},
        rest_quick,
        rest_billing,
        rest_transport,
        rest_b2b,
        !!requestedAt && { requestedAt: FormatUtils.intervalFilter(requestedAt?.start, requestedAt?.end) },
        !!company && { service: { contract: { company } } },
        !!contract && { service: { contract } },
        !!service && { service },
        !!commercial_formula && {
          or: [
            { do: { commercial_formula }, service: null },
            { service: { contract: { formula: commercial_formula } } }
          ]
        },
        !!rest_quick?.do?.auth?.gsm && { do: { auth: { gsm: FormatUtils.parsePhoneNumber(rest_quick?.do?.auth?.gsm, `+${codeIntlPhone}`) } } },
        !!loads?.src_contact && { loads: { src_contact: { contains: loads?.src_contact } } },
        !!order_client_id && { order_client_id: { contains: order_client_id } },
        !!source?.name && {
          source: {
            or: [
              { name: { contains: source?.name } },
              { poi: { name: { contains: source?.name } } }
            ]
          }
        },
        !!priority && {
          or: [
            { service: { priority } },
            { service: { contract: { priority } } },
            { service: { contract: { company: { priority } } } },
            { service: { companyusers: { priority } } },
            { service: null, do: { customerinfo: { priority } } }
          ]
        },
        !!billing_status && { billing_status },
        !!rest_transport?.assigned_transport?.vehicle?.info?.plaque && {
          assigned_transport: { vehicle: { info: { plaque: { contains: rest_transport?.assigned_transport?.vehicle?.info?.plaque } } } }
        },
      )
    }
  }
}

export default OrderCallbacks
